__turbopack_context__.v({
  "ImagePreview": "ImagePreview-module__GXn5Ha__ImagePreview",
  "active": "ImagePreview-module__GXn5Ha__active",
  "img": "ImagePreview-module__GXn5Ha__img",
  "mySwiper": "ImagePreview-module__GXn5Ha__mySwiper",
  "mySwiper2": "ImagePreview-module__GXn5Ha__mySwiper2",
  "slide": "ImagePreview-module__GXn5Ha__slide",
  "swiper": "ImagePreview-module__GXn5Ha__swiper",
});
